<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="8" lg="9">
            <h3 tabindex="0">Moções</h3>
          </b-col>
          <b-col sm="12" md="4" lg="3">
            <b-button md="6" :disabled="loading" @click="navigate('/mocao/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Nova Moção</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <b-form-input type="text" id="name" v-model="filtros.filter"
                placeholder="Título da moção..."></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="perfil.is_admin_conferencia">
          <b-col sm="2" md="6" lg="3">
            <b-form-group label="Situação:">
              <b-form-select v-model="filtros.situacao" class="mb-3">
                <option selected :value="null"> Selecione </option>
                <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" @click="pesquisar()">
              <i class="fa fa-search"></i>&nbsp;Pesquisar
            </b-button>
          </b-col>
          <b-col v-if="!loading" sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" @click="exportar">
              <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar</span>
            </b-button>
          </b-col>
          <b-col v-if="loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" :disabled="true">
              <b-spinner small type="grow"></b-spinner>Exportando...</b-button>
          </b-col>
        </b-row>
      </b-card-body>

      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-col class="table-responsive">
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                  class="table table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" tabindex="0" style="width: 10%" v-if="perfil.is_admin_conferencia">Enviar Moções</th>
                      <th scope="col" tabindex="0" style="width: 10%" v-if="perfil.is_admin_conferencia">Suspender Moções</th>
                      <th scope="col" tabindex="0" style="width: 5%">Aprovação</th>
                      <th scope="col" tabindex="0" style="width: 5%">Rejeição</th>
                      <th scope="col" tabindex="0" style="width: 30%; word-break: break-all;">Título</th>
                      <th scope="col" tabindex="0" style="width: 20%">Autor</th>
                      <th scope="col" tabindex="0" style="width: 10%">Status</th>
                      <th scope="col" v-if="perfil.is_admin_conferencia" tabindex="0">Visibilidade após encerramento</th>
                      <th scope="col" tabindex="0" style="width: 10%">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="mocoes.data !== undefined">
                    <tr class="action" v-for="mocao in mocoes.data" :key="mocao.id">
                      <td v-if="perfil.is_admin_conferencia">
                        <label class="form-checkbox">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" :id="'defaultInline1' + mocao.id"
                              :value="mocao.id" v-model="selecionados" :disabled="mocao.situacao == 'E'"
                              :checked="mocao.situacao == 'E'">
                            <label class="custom-control-label" :for="'defaultInline1' + mocao.id"></label>
                          </div>
                        </label>
                      </td>
                      <td v-if="perfil.is_admin_conferencia">
                        <label class="form-checkbox">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" :id="'defaultInline2' + mocao.id"
                              :value="mocao.id" v-model="selecionados_suspender" :disabled="mocao.situacao == 'S'"
                              :checked="mocao.situacao == 'S'">
                            <label class="custom-control-label" :for="'defaultInline2' + mocao.id"></label>
                          </div>
                        </label>
                      </td>
                      <td tabindex="0">{{ mocao.totalAprovado }}</td>
                      <td tabindex="0">{{ mocao.totalRejeitado }}</td>
                      <td tabindex="0">{{ mocao.titulo }}</td>
                      <td tabindex="0">{{ mocao.user ? mocao.user.nome : '' }}</td>
                      <td>
                        <b-button tabindex="0" size="sm" pill v-if="mocao.situacao === 'C'"
                          :disabled="!(perfil.is_admin_conferencia && (mocao.situacao === 'C' || mocao.situacao === 'S'))"
                          @click="enviarMocao(mocao.id)" variant="primary">Salvo</b-button>
                        <b-button tabindex="0" size="sm" pill v-if="mocao.situacao === 'E'"
                          :disabled="!(mocao.situacao === 'E' && perfil.is_admin_conferencia)"
                          @click="suspenderMocao(mocao.id)" variant="success">Publicado</b-button>
                        <b-button tabindex="0" size="sm" pill v-if="mocao.situacao === 'S'" variant="danger">Suspenso</b-button>
                        <b-button tabindex="0" size="sm" pill v-if="mocao.situacao === 'G'" variant="warning">Aguardando aprovação</b-button>
                        <b-button tabindex="0" size="sm" pill v-if="mocao.situacao === 'R'" variant="danger">Reprovado</b-button>
                      </td>
                      <td v-if="perfil.is_admin_conferencia">
                        <b-button tabindex="0" size="sm" v-if="mocao.visivel_encerrado"
                          @click="desativaVisibilidade(mocao.id)" pill variant="success">Visível</b-button>
                        <b-button tabindex="0" size="sm" v-if="!mocao.visivel_encerrado"
                          @click="ativaVisibilidade(mocao.id)" pill variant="danger">Não Visível</b-button>
                      </td>
                      <td style="width: 15%">
                        <b-button tabindex="0"
                          v-if="perfil.is_admin_conferencia && (mocao.situacao === 'C' || mocao.situacao === 'S')"
                          class="btn btn-sm btn-secondary action" title="Editar" @click="editarMocao(mocao.id)">
                          <i class="fa fa-pencil-square-o"></i>
                        </b-button>

                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar"
                          @click="visualizarMocao(mocao.id)">
                          <i class="fa fa-search"></i>
                        </b-button>

                        <b-button tabindex="0" v-if="mocao.situacao === 'G' && perfil.is_admin_conferencia"
                          class="btn btn-sm btn-secondary action" title="Reprovar" @click="reprovarMocao(mocao.id)">
                          <i class="fa fa-trash"></i>
                        </b-button>

                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" v-if="perfil.is_admin_conferencia"
                          title="Exportar" @click="exportarMocao(mocao.id)">
                          <i class="fa fa-file"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td :colspan="9" tabindex="0">Nenhuma moção cadastrada</td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <pagination tabindex="0" v-show="mocoes.data !== undefined" :totalPorPagina="totalPorPagina"
                :resource="resource" :filtros="filtros">
              </pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
      <b-card-footer class="p-12">
        <b-row v-if="perfil.is_admin_conferencia">
          <b-col sm="12" md="4" lg="3" >
            <b-button block  @click="suspenderMocaoLote()">
              <span>Suspender Moção</span>
            </b-button>
          </b-col>
          <b-col sm="12" md="4" lg="3" >
            <b-button block variant="primary" @click="enviarMocoes()">
              <i class="fa fa-envelope"></i>&nbsp;&nbsp;<span>Enviar Moção</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  name: 'Mocao',
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created() {
    //
  },
  data() {
    return {
      totalPorPagina: 30,
      resource: 'mocao',
      filtros: {
        filter: null,
        situacao: null
      },
      situacoes: [
        { 'value': 'C', 'text': 'Salvo' },
        { 'value': 'E', 'text': 'Enviado' },
        { 'value': 'S', 'text': 'Suspenso' },
        { 'value': 'G', 'text': 'Aguardando Aprovação' },
        { 'value': 'R', 'text': 'Reprovado' }

      ],
      selecionados: [],
      selecionados_suspender: []
    }
  },
  computed: {
    mocoes() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState() {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    },
    perfil() {
      return this.$store.state.perfil.perfil
    }
  },
  methods: {
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar() {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
    },
    editarMocao(id) {
      this.$router.push('/mocao/editar/' + id)
    },
    visualizarMocao(id) {
      this.$router.push('/mocao/visualizar/' + id)
    },
    exportar() {
      this.loading = true
      const d = new Date();

      Vue.http.post('api/mocao/exportar', { filtros: this.filtros }, { responseType: 'blob' }).then(response => {
        if (response.ok) {         
          let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)

          let time = d.getTime();
          link.download = 'Mocoes' + time + '.xlsx'
          link.click()
        }
        this.loading = false
      })
    },
    enviarMocao(id) {
      let data = []
      data.push(id)
      this.$bvModal.msgBoxConfirm('Deseja enviar a moção?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/enviado/publicacao', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    enviarMocoes() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/mocao/enviado/publicacao', this.selecionados).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.selecionados = []
            this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderMocaoLote() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/suspenso/lote', this.selecionados_suspender).then(response => {
            if (response.body.success) {
              this.selecionados_suspender = []
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderMocao(id) {
      this.$bvModal.msgBoxConfirm('Deseja suspender a visualização da moção?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/' + id + '/suspenso').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    reprovarMocao(id) {
      this.$bvModal.msgBoxConfirm('Deseja reprovar a moção?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/' + id + '/reprovado').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    desativaVisibilidade(id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja desativar visiblidade após encerramento?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/' + id + '/desativar_visibilidade').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            } this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    ativaVisibilidade(id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja ativar visiblidade após encerramento?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/mocao/' + id + '/ativar_visibilidade').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina })
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            } this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    exportarMocao(mocao) {
      window.location.href = process.env.ROOT_API1 + 'api/mocao/' + mocao + '/exportar'
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}</style>



// WEBPACK FOOTER //
// src/pages/site/interna/mocao/Mocao.vue